import React, { useEffect, useRef } from 'react';
import { Form, InputNumber } from 'antd';

const SpinToWinLimitForm = ({
  initialValues,
  onSubmit,
  setOuterSubmitFn,
  setOuterSubmitDisabled,
}) => {
  const inputRef = useRef();

  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues && initialValues.dailyLimit !== undefined) {
      form.setFieldsValue({ dailyLimit: initialValues.dailyLimit });
    }
  }, [initialValues, form]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);

  useEffect(() => {
    if (setOuterSubmitFn) {
      setOuterSubmitFn(() => form.submit);
    }
  }, [setOuterSubmitFn, form]);

  useEffect(() => {
    if (setOuterSubmitDisabled) {
      setOuterSubmitDisabled(false);
    }
  }, [setOuterSubmitDisabled]);

  const onFinish = (values) => {
    onSubmit(values);
  };

  const limitRules = [
    {
      required: true,
      message: 'Please enter a daily limit',
    },
    {
      validator(rule, value) {
        if (value > 0 && value <= 2000) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('Please enter a valid daily limit (1 - 2000)'));
      },
    },
  ];

  return (
    <Form
      name="spinToWin"
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}
      validateTrigger="onSubmit"
    >
      <Form.Item
        label="Daily Limit"
        name="dailyLimit"
        rules={limitRules}
      >
        <InputNumber
          className="col-4"
          ref={inputRef}
          autocomplete="off"
          min={1}
          max={2000}
          placeholder="Enter daily limit"
        />
      </Form.Item>
    </Form>
  );
};

export default SpinToWinLimitForm;



// WEBPACK FOOTER //
// ./src/js/common/components/SpinToWinLimitForm/index.jsx